import { TDurationFilterType } from 'libs/ui/src/lib/filter/model/ui-filter.types';
import moment from 'moment';

type Error = 'START_IS_GREATER' | 'RANGE_OUT_OF_WEEK_LENGTH' | 'START_OUT_OF_MONTH_RANGE';

export const DATE_FILTER_UTIL = {
  isValid(
    dateFilter: TDurationFilterType,
    startLimit: number,
    range: number,
  ): { isValid: boolean; error: Error | null } {
    const startAndEndTime = this.getStartAndEndTime(dateFilter);
    console.log(new Date().setHours(0, 0, 0, 0) - new Date(startAndEndTime.start).setHours(0, 0, 0, 0));
    if (startAndEndTime.start > startAndEndTime.end) {
      return {
        isValid: false,
        error: 'START_IS_GREATER',
      };
    } else if (
      new Date().setHours(0, 0, 0, 0) - new Date(startAndEndTime.start).setHours(0, 0, 0, 0) >
      startLimit * 86400000
    ) {
      return {
        isValid: false,
        error: 'START_OUT_OF_MONTH_RANGE',
      };
    } else if (
      new Date(startAndEndTime.end).setHours(0, 0, 0, 0) - new Date(startAndEndTime.start).setHours(0, 0, 0, 0) >
      range * 86400000
    ) {
      return {
        isValid: false,
        error: 'RANGE_OUT_OF_WEEK_LENGTH',
      };
    } else return { isValid: true, error: null };
  },
  getStartAndEndTime(dateFilter: TDurationFilterType) {
    const currentTime = moment().valueOf();
    switch (dateFilter.type) {
      case 'TODAY': {
        return {
          start: currentTime,
          end: currentTime,
        };
      }
      case 'YESTERDAY': {
        return {
          start: moment(currentTime).subtract(1, 'days').valueOf(),
          end: moment(currentTime).subtract(1, 'days').valueOf(),
        };
      }
      case 'WEEKLY': {
        return {
          start: moment(currentTime).subtract(7, 'days').valueOf(),
          end: currentTime,
        };
      }
      case 'MONTHLY': {
        return {
          start: moment(currentTime).subtract(30, 'days').valueOf(),
          end: currentTime,
        };
      }
      case 'CUSTOM': {
        return {
          start: dateFilter.start as number,
          end: dateFilter.end as number,
        };
      }
    }
  },

  getDateDs(dateFilter: TDurationFilterType) {
    const startAndEndTime = DATE_FILTER_UTIL.getStartAndEndTime(dateFilter);
    if (startAndEndTime.start === startAndEndTime.end) {
      return moment(startAndEndTime.start).format('ll');
    }
    return moment(startAndEndTime.start).format('ll') + ' - ' + moment(startAndEndTime.end).format('ll');
  },
};
